import { pdfjs } from 'react-pdf';

// Configure PDF.js worker for Create React App
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default pdfjs;